export const SHOW_NOTIFICATION = 'ui/SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'ui/HIDE_NOTIFICATION'



// WEBPACK FOOTER //
// ./state/types/notification.js